import React, { useState } from "react"
import PropTypes from "prop-types"
import { Space, Button, Upload } from "antd"
import { DownloadOutlined, UploadOutlined, CloseOutlined } from "@ant-design/icons"

import { getCustomRequest } from "@components/Import"

import useExport from "./helpers/useExport"
import useTemplateParser from "./helpers/useTemplateParser"
import { InvestmentShape } from "../shapes"

const LABEL_UPLOAD_TEMPLATE = "Select Template"
const LABEL_DOWNLOAD_TEMPLATE = "CSV Template"


const Import = ({
  table,
  setErrors,
  targetProjectId,
  sourceProjectId,
  sourceInvestments,
  setCustomAmounts,
}) => {
  const [ file, setFile ] = useState()

  const getItems = () => table.current.getDataSource().filter(({ isIncluded }) => isIncluded)

  const onExportClick = useExport({
    getItems,
    sourceProjectId,
    targetProjectId,
    sourceInvestments,
  })

  const onChange = () => {}
  const { parseRow, validateRow, buildRow } = useTemplateParser(setErrors, getItems, targetProjectId)

  const callbackUpload = selectedFile => setFile(selectedFile)
  const callbackSuccess = value => setCustomAmounts(value)

  const customRequest = getCustomRequest(parseRow, validateRow, buildRow, callbackSuccess, callbackUpload)

  const onReset = () => {
    setFile()
    setErrors([])
    setCustomAmounts([])
  }

  return (
    <Space>
      <Button
        icon={<DownloadOutlined />}
        onClick={onExportClick}
      >
        {LABEL_DOWNLOAD_TEMPLATE}
      </Button>

      {
        !file && (
          <Upload
            accept=".csv"
            multiple={false}
            onChange={onChange}
            customRequest={customRequest}
            showUploadList={false}
          >
            <Button
              type="primary"
              icon={<UploadOutlined />}
              onClick={() => {}}
            >
              {LABEL_UPLOAD_TEMPLATE}
            </Button>
          </Upload>
        )
      }

      {
        file && (
          <span>
            {file.name}
          </span>
        )
      }

      {
        file && (
          <Button
            icon={<CloseOutlined />}
            size="small"
            type="text"
            shape="circle"
            onClick={onReset}
          />
        )
      }
    </Space>
  )
}

Import.propTypes = {
  table: PropTypes.shape().isRequired,
  targetProjectId: PropTypes.string.isRequired,
  sourceProjectId: PropTypes.string.isRequired,
  sourceInvestments: PropTypes.arrayOf(InvestmentShape).isRequired,
  setErrors: PropTypes.func.isRequired,
  setCustomAmounts: PropTypes.func.isRequired,
}

export default Import
